module.exports = __webpack_public_path__ + "static/media/student27.efc91f9e.png";